import { startDateOptions } from '../components/CallbackForm/start-date-options';

export function useRAQJobStartDate() {
  return {
    title: 'When would you like the job to start?',
    options: startDateOptions,
  };
}
